var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useImperativeHandle, useState, } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ComposerAnalyticsEvent, ComposerMode, useSafeFormData, } from '../types/index';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { useHandleEventUpdate } from '../hooks/useHandleEventUpdate';
import { useEventComposerGlobalContext } from './EventComposerGlobalContext';
import { useEventApi } from '../hooks/useEvent/useEventApi';
import { useConfig } from '../context/ConfigContext';
import { useSpacePrivacySettings } from '../hooks/useSpacePrivacySettings';
import { shouldUpdateAsSpace } from '../utils/payloadBuilders';
import { recordEventSave } from '../utils/recentEventSaves';
import { useApprovedRequestFieldsLocked } from '../hooks/useApprovedRequestFieldsLocked';
var EditEventContext = createContext({
    initialEvent: undefined,
    eventPermissions: undefined,
    handleEventUpdate: function () { },
    recurringEventToUpdate: null,
    setRecurringEventToUpdate: function () { },
    performSave: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, 'update_failed'];
    }); }); },
    editEventError: null,
    updatingEvent: false,
    setEditEventError: function () { },
    shouldShowPrivacyIndicator: false,
    spaceReservationVisibilityEnabled: false,
});
export var EditEventContextProvider = function (_a) {
    var _b, _c;
    var children = _a.children, onClose = _a.onClose, onSubmit = _a.onSubmit, onEventChange = _a.onEventChange, initialEvent = _a.initialEvent, eventPermissions = _a.eventPermissions, fetchingEvent = _a.fetchingEvent, composerRef = _a.composerRef, requestClose = _a.requestClose;
    var _d = useConfig(), tenantId = _d.tenantId, environmentUrls = _d.environmentUrls, userContext = _d.userContext, accessToken = _d.accessToken;
    var _e = useEventComposerGlobalContext(), timezone = _e.timezone, onError = _e.onError, onTrackComposerEvent = _e.onTrackComposerEvent, requestOnlySpace = _e.requestOnlySpace;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var _f = useFormContext(), subscribe = _f.subscribe, setValue = _f.setValue, getValues = _f.getValues;
    var formData = useSafeFormData();
    var t = useTranslation('meetingRooms').t;
    var _g = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), updateEvent = _g.updateEvent, editEventError = _g.eventError, setEditEventError = _g.setEventError, updatingEvent = _g.composingEvent;
    var _h = useCalendarIntegrationsContext(), calendarType = _h.calendarType, calendarMailboxAddress = _h.calendarMailboxAddress;
    var _j = __read(useState(null), 2), recurringEventToUpdate = _j[0], setRecurringEventToUpdate = _j[1];
    // The single EDIT save executor: PATCH → cooldown → analytics → submit →
    // close. Removed spaces ride the PATCH by omission (the API removes
    // absent invitees and frees their rooms). Both entry points (the plain
    // Update path and UpdateRecurringEventModal) run this; callers clean up
    // their own state per outcome.
    var performSave = useCallback(function (payload, options) { return __awaiter(void 0, void 0, void 0, function () {
        var eventId, updateAsSpace, response, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    eventId = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.id;
                    if (!eventId) {
                        onError(new Error(t('update_event.no_event_id_found')));
                        return [2 /*return*/, 'update_failed'];
                    }
                    updateAsSpace = shouldUpdateAsSpace(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.eventPermissions);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateEvent(payload, eventId, options.seriesOption, updateAsSpace, (_b = options.recurrenceChanged) !== null && _b !== void 0 ? _b : false, (initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.reservationApproval) != null)];
                case 2:
                    response = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _c.sent();
                    // updateEvent set editEventError; the ErrorModal owns retry.
                    onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                        mode: ComposerMode.EDIT,
                    });
                    return [2 /*return*/, 'update_failed'];
                case 4:
                    if (!response) {
                        // updateEvent resolves undefined ONLY when the request was aborted
                        // (the composer is closing) — a real failure sets editEventError
                        // and throws. Nothing to toast, track, or close.
                        return [2 /*return*/, 'aborted'];
                    }
                    // The PATCH's calendar sync is now in flight — start the details
                    // panel's change-room cooldown for this event (both ids: "this and
                    // following" edits return a new one).
                    recordEventSave(eventId, response.data.id);
                    onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_UPDATED, __assign({ updatedAsSpace: updateAsSpace }, options.analytics));
                    onSubmit(response.data, ComposerMode.EDIT);
                    onClose();
                    return [2 /*return*/, 'saved'];
            }
        });
    }); }, [
        initialEvent,
        updateEvent,
        onError,
        onClose,
        onSubmit,
        onTrackComposerEvent,
        t,
    ]);
    var _k = useSpacePrivacySettings((_b = formData.spaces) !== null && _b !== void 0 ? _b : []), spaceReservationVisibilityEnabled = _k.spaceReservationVisibilityEnabled, shouldShowPrivacyIndicator = _k.shouldShowPrivacyIndicator;
    var handleEventUpdate = useHandleEventUpdate({
        formData: formData,
        timezone: timezone,
        initialEvent: initialEvent,
        calendarType: calendarType,
        calendarMailboxAddress: calendarMailboxAddress,
        performSave: performSave,
        setRecurringEventToUpdate: setRecurringEventToUpdate,
        onError: onError,
    }).handleEventUpdate;
    useEffect(function () {
        if (fetchingEvent)
            return;
        if (!onEventChange)
            return;
        var callback = subscribe({
            formState: {
                values: true,
            },
            callback: function (_a) {
                var values = _a.values;
                onEventChange(values);
            },
        });
        return function () { return callback(); };
    }, [subscribe, onEventChange, fetchingEvent]);
    // On an approved request-only event, non-approvers can't change date/time
    // — the same lock that disables those fields in DateTimeWrapper/Buffers.
    var timeFieldsLocked = useApprovedRequestFieldsLocked(requestOnlySpace, (_c = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.reservationApproval) === null || _c === void 0 ? void 0 : _c.approved);
    // The host's imperative handle is registered here — not in
    // EditEventComposer like CREATE — so the patch policy can read the
    // approval lock from context. Consequence: while the event is still
    // fetching, this provider isn't mounted and the handle is null. The
    // shell then drops inbound patches (net-equal to today: an early patch
    // would be wiped by the form reset when the fetched event arrives) and
    // falls back to a direct close on sider-foreground requests (nothing
    // user-dirtied exists during load).
    useImperativeHandle(composerRef, function () { return ({
        patchFormValues: function (patch) {
            // External time patches (grid pill moves) must respect the lock,
            // or they'd write straight past the disabled fields and be saved.
            // Re-emit the unchanged form values instead of dropping silently:
            // the echo is what snaps the sender's optimistically-moved pill
            // back — no form change means no echo.
            if (timeFieldsLocked) {
                onEventChange === null || onEventChange === void 0 ? void 0 : onEventChange(getValues());
                return;
            }
            var opts = { shouldDirty: true, shouldValidate: true };
            if (patch.date !== undefined) {
                setValue('date', patch.date, opts);
            }
            if (patch.startTime !== undefined) {
                setValue('startTime', patch.startTime, opts);
            }
            if (patch.endTime !== undefined) {
                setValue('endTime', patch.endTime, opts);
            }
        },
        requestClose: requestClose,
    }); }, [timeFieldsLocked, onEventChange, getValues, setValue, requestClose]);
    return (_jsx(EditEventContext.Provider, { value: {
            initialEvent: initialEvent,
            eventPermissions: eventPermissions,
            handleEventUpdate: handleEventUpdate,
            recurringEventToUpdate: recurringEventToUpdate,
            setRecurringEventToUpdate: setRecurringEventToUpdate,
            performSave: performSave,
            editEventError: editEventError,
            updatingEvent: updatingEvent,
            setEditEventError: setEditEventError,
            shouldShowPrivacyIndicator: shouldShowPrivacyIndicator,
            spaceReservationVisibilityEnabled: spaceReservationVisibilityEnabled,
        }, children: children }));
};
export var useEditEventContext = function () {
    return useContext(EditEventContext);
};
